// src/services/itemDeliveryService.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

// const getItemDeliveries = async () => {
//   return await axios.get(`${API_URL}/item_delivery`);
// };

const deliveryReport = async () => {
  const event_id = localStorage?.getItem('event_id');
  return await axios.get(
    `${API_URL}/item_delivery/stationproductslist/${event_id}`
  );
};

const getItemDeliveries = async (id) => {
  return await axios.get(`${API_URL}/item_delivery/delivery/${id}`);
};

const getItemDeliveriesDetails = async () => {
  const event_id = localStorage?.getItem('event_id');
  return await axios.get(`${API_URL}/item_delivery/details/${event_id}`);
};

const getItemDelivery = async (id) => {
  return await axios.get(`${API_URL}/item_delivery/${id}`);
};

const createItemDelivery = async (itemDeliveryData) => {
  return await axios.post(`${API_URL}/item_delivery/`, itemDeliveryData);
};

const updateItemDelivery = async (station, itemDeliveryData) => {
  const event_id = localStorage?.getItem('event_id');
  return await axios.post(
    `${API_URL}/item_delivery/stationitemsupdate/${event_id}/${station}`,
    itemDeliveryData
  );
};

const updateItemDeliveryAllotedQty = async (id, itemDeliveryData) => {
  return await axios.put(`${API_URL}/item_delivery/${id}`, itemDeliveryData);
};

const deleteItemDelivery = async (id) => {
  return await axios.delete(`${API_URL}/item_delivery/${id}`);
};

const itemDeliveryLogs = async (id) => {
  return await axios.get(`${API_URL}/item_delivery/deliverylogs/${id}`);
};

const getItemByStation = async (station) => {
  const event_id = localStorage?.getItem('event_id');
  return await axios.get(
    `${API_URL}/item_delivery/productsbystation/${event_id}/${station}`
  );
};

const getItemByUser = async (user_id) => {
  return await axios.get(`${API_URL}/item_delivery/items_by_user/${user_id}`);
};

export default {
  getItemDeliveries,
  getItemDeliveriesDetails,
  getItemDelivery,
  createItemDelivery,
  updateItemDelivery,
  deleteItemDelivery,
  deliveryReport,
  itemDeliveryLogs,
  getItemByStation,
  getItemByUser,
  updateItemDeliveryAllotedQty
};
